var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelihoistLightWithSro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2079,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1697,
    y: 314,
    width: 2079,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1697 -314)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1697,
    y: 314,
    width: 2079,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2141 1346.5C2141 998.284 2423.28 716 2771.5 716 3119.72 716 3402 998.284 3402 1346.5 3402 1694.72 3119.72 1977 2771.5 1977 2423.28 1977 2141 1694.72 2141 1346.5Z",
    fill: "#4472C4",
    fillRule: "evenodd",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2534 1353 2736.5 1150 2939 1353 2736.5 1556Z",
    stroke: "#000000",
    strokeWidth: 48.125,
    strokeMiterlimit: 8,
    fill: "#81F248",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelihoistLightWithSro);
export default __webpack_public_path__ + "static/media/HelihoistLightWithSRO.9691628b87292c4d80451f2c61dfbbc6.svg";
export { ForwardRef as ReactComponent };